export default __webpack_public_path__ + "static/media/central_andes_2_20.a75d96e6.JPG";